import GLightbox from 'glightbox'

export default () => {

    const downloads = document.querySelectorAll('[data-download-popup]');
    if (downloads.length) {
        GLightbox({
            selector: '[data-download-popup]',
            videosWidth: 1130
        });
    }

    const videos = document.querySelectorAll('[data-video-popup]');
    if (videos.length) {
        GLightbox({
            selector: '[data-video-popup]',
            videosWidth: 1130
        });
    }

}
